import { SxProps } from '@mui/material';

interface PaymentSummaryBoxStyles {
  container: SxProps & { width: string | number };
  headerText: SxProps;
  totalAmount: SxProps;
  itemText: SxProps;
  payableLabel: SxProps;
  summaryLoader: SxProps;
}

export const styles: PaymentSummaryBoxStyles = {
  container: {
    background: 'linear-gradient(135deg, #6A11CB 0%, #2575FC 100%)',
    color: 'white',
    padding: '24px',
    width: '463px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  headerText: {
    fontWeight: 400,
    fontSize: '16px',
    top: '35px',
    lineHeight: '20px',
  },
  totalAmount: {
    mt: 1,
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '38px',
  },
  itemText: {
    paddingTop: '30px',
    fontWeight: 300,
    fontSize: '14px',
    lineHeight: '18px',
    color: 'rgba(255, 255, 255, 0.63)',
  },
  payableLabel: {
    fontWeight: 300,
    fontSize: '14px',
    lineHeight: '18px',
  },
  summaryLoader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
};
